import { useEffect, useState } from 'react';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { Button } from '@mui/material';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import TestPingQuery from '../../services/query/testPing/TestPingQuery';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import { TSU } from './testServicesUrl.classes';

const applyPingResultToUrlList = (currentList: any[], serviceName: string, res: any) =>
    currentList.map((listItem: any) => {
        if (listItem.serviceName === serviceName) {
            return {
                ...listItem,
                responseTime: res.responseTime,
                status: res.isSuccessful,
                reasonPhrase: res.reasonPhrase,
            };
        }
        return listItem;
    });

function TestServicesUrl() {
    const { t } = useTranslation();
    const [urlList, setUrlList] = useState<any>();
    const [loading, setLoading] = useState(false);
    const environment = import.meta.env.VITE_ENVIRONMENT!.toString().toLowerCase();
    const checkServiceStatus = async () => {
        setLoading(true);

        await Promise.all(
            urlList.map(async (item: any) => {
                const req = {
                    serviceEndpointURL: item.serviceEndpointURL,
                    serviceName: item.serviceName,
                };
                try {
                    const res: any = await TestPingQuery.PingToUrls(req);
                    setUrlList((currentList: any) => applyPingResultToUrlList(currentList, item.serviceName, res));
                } catch (error) {
                    console.error('Error pinging service URL:', error);
                }
            })
        );
        setLoading(false);
    };
    const getTestPingUrls = () => {
        TestPingQuery.GetTestPingUrls(environment)
            .then((res: any) => {
                if (res) {
                    let parseData = res.model.map((item: any) => {
                        return {
                            id: item.serviceEndpointId || '-',
                            serviceName: item.serviceName || ' ',
                            serviceEndpointEnvironment: item.serviceEndpointEnvironment || ' ',
                            serviceEndpointURL: item.serviceEndpointURL || ' ',
                            responseTime: item.responseTime,
                        };
                    });
                    setUrlList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    useEffect(() => {
        getTestPingUrls();
    }, []);

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90, flex: 1, hide: true },
        {
            field: 'serviceName',
            headerName: 'Service Adı',
            width: 150,
            flex: 1,
        },
        {
            field: 'serviceEndpointEnvironment',
            headerName: 'ServiceEndpointEnvironment',
            width: 160,
            flex: 1,
        },
        {
            field: 'serviceEndpointURL',
            headerName: 'ServiceEndpointURL',
            width: 160,
            flex: 1,
        },
        {
            field: 'responseTime',
            headerName: 'Response Time',
            width: 160,
            flex: 1,
        },
        {
            field: 'status',
            headerName: 'Durum',
            width: 100,
            flex: 1,
            sortable: false,
            renderCell: (params) => {
                return (
                    <span className={TSU.cellStatusWrap}>
                        {loading ? (
                            <CircularProgress size={24} className={TSU.cellStatusLoading} />
                        ) : params.value ? (
                            <CheckCircleIcon style={{ color: 'green' }} className={TSU.cellStatusOk} />
                        ) : (
                            <CancelIcon style={{ color: 'red' }} className={TSU.cellStatusFail} />
                        )}
                    </span>
                );
            },
        },
        {
            field: 'reasonPhrase',
            headerName: t('general.description'),
            width: 160,
            flex: 1,
        },
    ];

    return (
        <SCUIContent className={TSU.page}>
            <p className={TSU.environmentRow}>
                Bulunduğunuz ortam: {environment}{' '}
            </p>
            <Button
                variant="contained"
                color="primary"
                onClick={checkServiceStatus}
                style={{ height: '30px', padding: '5px' }}
                className={TSU.checkButton}
            >
                <p className={TSU.checkButtonLabel} style={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>
                    Servis Durumlarını Kontrol Et
                </p>
            </Button>
            {urlList && (
                <div className={TSU.gridWrap}>
                    <SCUICustomDataGrid
                        rows={urlList}
                        pageSize={30}
                        columns={columns}
                        initialState={{
                            sorting: {
                                sortModel: [
                                    {
                                        field: 'id',
                                        sort: 'asc',
                                    },
                                ],
                            },
                        }}
                    />
                </div>
            )}
        </SCUIContent>
    );
}

export default TestServicesUrl;
